<template>
  <div class="headline-numbers" id="headline">
    <table v-if="numbers">
      <thead>
        <tr>
          <th></th>
          <th v-for="{key, text} in headers" :key="key" :class="key"><div>{{text}}</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{key, text, value: rows} in numbers" :key="key" :class="key">
          <th v-html="text"></th>
          <td v-for="{key, value} in rows" :key="key" :class="key">
            {{value | formatNumber}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { store } from "./wuhanData";

export default {
  props: ["attributes"],
  computed: {
    headers() {
      return [
        { key: "cases", text: "Confirmed cases" },
        // { key: "recovered", text: "Recovered" },
        { key: "deaths", text: "Deaths" },
      ];
    },
    numbers() {
      if (!store.rawData) return null;
      let totalCases = 0;
      let totalDeaths = 0;
      // let totalRecovered = 0;
      let asiaCases = 0;
      let asiaDeaths = 0;
      // let asiaRecovered = 0;
      let sRow;
      store.rawData.forEach(row => {
        if (row.country === "Singapore") sRow = row;
        if (!row.country) return;
        totalCases += row.cases;
        totalDeaths += row.deaths;
        // totalRecovered += row.recovered;
        if (row.region === "Asia") {
          asiaCases += row.cases;
          asiaDeaths += row.deaths;
          // asiaRecovered += row.recovered;
        }
      });
      const world = {
        key: "world",
        text: "Worldwide",
        value: [
          { key: "cases", value: totalCases },
          // { key: "recovered", value: totalRecovered },
          { key: "deaths", value: totalDeaths },
        ],
      };

      const asia = {
        key: "asia",
        text: "Asia",
        value: [
          { key: "cases", value: asiaCases },
          // { key: "recovered", value: asiaRecovered },
          { key: "deaths", value: asiaDeaths },
        ],
      };

      const singapore = {
        key: "singapore",
        text: "Singapore",
        value: [
          { key: "cases", value: sRow.cases },
          // { key: "recovered", value: sRow.recovered },
          { key: "deaths", value: sRow.deaths },
        ],
      };
      return [world, asia, singapore];
    },
  },
  filters: {
    formatNumber(n) {
      return n.toLocaleString();
    },
  },
};
</script>
<style lang="scss">
.headline-numbers {
  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
  }

  th,
  td {
    text-align: center;
    padding: 5px 2px;

    @include breakpoint($d_medium) {
      padding: 10px;
    }

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }

  thead {
    th {
      font-family: $font-CuratorBold;
      font-size: 15px;

      &:first-child {
        width: 80px;

        @include breakpoint($d_medium) {
          // width: 100px;
          width: 85px;
        }
      }

      div {
        border-radius: 3px;
        padding: 0.5em 2px;
      }

      &.cases div {
        color: rgb(212, 136, 61);
        background-color: rgba(212, 136, 61, 0.1);
      }

      &.recovered div {
        color: rgb(2, 199, 191);
        background-color: rgba(2, 199, 191, 0.1);
      }

      &.deaths div {
        color: rgb(149, 35, 112);
        background-color: rgba(149, 35, 112, 0.1);
      }
    }
  }

  tbody {
    th {
      font-family: $font-CuratorRegular;
      font-size: 15px;
      color: #333333;
      text-align: left;
      text-transform: uppercase;
    }

    td {
      font-family: $font-SelaneTen;
      font-size: 21px;

      @include breakpoint($d_medium) {
        font-size: 36px;
      }

      &.cases {
        color: #d4883d;
      }

      &.recovered {
        color: #02c7bf;
      }

      &.deaths {
        color: #952370;
      }
    }

    tr.world {
      border-bottom: 2px solid #666;

      th {
        font-family: $font-CuratorBold;
      }

      td {
        font-family: $font-SelaneFifty;
      }
    }
  }

  .disclaimer {
    font-size: 0.6em;
    font-family: $font-CuratorRegular;
    text-transform: none;
    line-height: 12px;
  }

  //added styles to adjust width
  @media screen and (max-width: 400px) {
    .cases {
      width: 90px;
    }
    .deaths {
      width: 80px;
    }
    thead {
      th {
        &:first-child {
          width: 60px;
        }
      }
    }
  }
  // @include breakpoint($d_medium) {
  //   .deaths {
  //     width: 170px;
  //   }
  // }
}
</style>
